module.exports = __webpack_public_path__ + "media/images/vp/samples/16-60feaff5d7a1b444a2207a5d7d85fe5d.jpg";